import controller from './family-plan-info.controller';

export default {
  bindings: {
    type: '<'
  },
  controller ,
  template: require('./family-plan-info.html')
};



// WEBPACK FOOTER //
// src/app/family-plan/family-plan-info/family-plan-info.component.ts